<template>
    <div class="pt-15 animated fadeIn scrollTableNoTab equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @new-item="newItem"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Posted'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:claim_date" slot-scope="data">
                                {{data.item.claim_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="data">
                                {{data.item.created_at  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="data">
                                {{ data.item.amount ? $accounting.formatMoney(data.item.amount, { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                            </template>
                            <template slot="gofix_table:tax_amount" slot-scope="data">
                                {{ data.item.tax_amount ? $accounting.formatMoney(data.item.tax_amount, { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                            </template>
                            <template slot="gofix_table:total_amount" slot-scope="data">
                                {{ data.item.total_amount ? $accounting.formatMoney(data.item.total_amount, { format: { pos : "%s %v", neg : "%s (%v)", zero: "--" } }) : '-' }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    const accounting = require('accounting');

    export default {
        name: 'MiscExpenses',
        components: {},
        data() {
            let filter = JSON.parse(JSON.stringify(filters['misc_expenses']));
            return {
                tableConfig:{
                    dataSelect: {
                        status: {
                            value: [
                                {value: 'Draft',             text: 'Draft'},
                                {value: 'Cancelled',         text: 'Cancelled'},
                                {value: 'Submitted',         text: 'Submitted'},
                                {value: 'PV Draft',          text: 'PV Draft'},
                                {value: 'PV Under Approval', text: 'PV Under Approval'},
                                {value: 'PV Approved',       text: 'PV Approved'},
                                {value: 'Posted',            text: 'Posted'},
                                {value: 'Paid',              text: 'Paid'}
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                    name: 'misc-expenses-listing',
                    controls:{
                        create: this.$checkRole(this.$accessModule.misc_expenses, 'create'),
                        delete: this.$checkRole(this.$accessModule.misc_expenses, 'delete'),
                        tableImport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
            }
        },
        created() {},
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            }),
        },
        methods: {
            /*---------- Table event ----------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("MiscExpensesController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.tableItems = [];
                        this.tableConfig.total = 0;
                        this.$alertNotification("Can not load Mics Expenses", "danger");
                        reject();
                    });
            },
            clickToRowItem(item){
                this.$router.push(`/v2/misc-expenses/${item.id}`);
            },
            newItem(){
                this.$router.push(`/v2/misc-expenses/0`);
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('MiscExpensesController/deteleItem', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'misc_expenses'))
                    })
                    .catch(err => {
                        reject();
                    });
            },
            exportItems(tableRequest) {
                this.$store.dispatch( 'MiscExpensesController/exportItems', tableRequest)
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'MiscExpense.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
        }
    }
</script>
